export default {
  "content": "<g fill-rule=\"evenodd\"><circle cx=\"256\" cy=\"321.64\" r=\"118\" stroke=\"#26c3dc\" stroke-width=\"80\" fill=\"none\"/><rect fill=\"var(--bv-color-indigo-4)\" width=\"90\" height=\"196\" x=\"51.48\" y=\"10.64\" rx=\"45\" transform=\"rotate(51 96.48 108.64)\"/><rect fill=\"var(--bv-color-purple-4)\" width=\"90\" height=\"196\" x=\"370.44\" y=\"10.64\" rx=\"45\" transform=\"scale(-1 1) rotate(51 0 -762.34)\"/></g>",
  "attrs": {
    "class": "bv-icon-operate",
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 0 512 512"
  }
};